import { IsOptional, IsString } from 'class-validator';
import { compra_asistida_estado } from '@prisma/client';
import { CreateCompraAsistidaDto } from './create-compra-asistida.dto';

export class UpdateCompraAsistidaDto extends CreateCompraAsistidaDto {
  @IsOptional()
  @IsString()
  estado_ca?: compra_asistida_estado;

  @IsOptional()
  @IsString()
  link_seguimiento?: string;
}
